export const ChartMode = {
  PIPS: 'pips',
  PERCENTAGE: 'percentage'
}

export const EIGHT_POINT_ASSESSMENT = 'eight_point_assessment'